function Button({ children, onClick, className = '' }) {
    return (
      <button
        onClick={onClick}
        className={`px-4 py-2 rounded-2xl font-semibold transition-colors ${className}`}
      >
        {children}
      </button>
    );
  }

export default Button;